const FACILITY_SHIFT_PREFIX = 'FACILITY_SHIFT_'
export const FACILITY_SHIFT = {
  LIST_REQUEST: `${FACILITY_SHIFT_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${FACILITY_SHIFT_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${FACILITY_SHIFT_PREFIX}LIST_FAILURE`,
  GET_ONE_REQUEST: `${FACILITY_SHIFT_PREFIX}GET_ONE_REQUEST`,
  GET_ONE_SUCCESS: `${FACILITY_SHIFT_PREFIX}GET_ONE_SUCCESS`,
  GET_ONE_FAILURE: `${FACILITY_SHIFT_PREFIX}GET_ONE_FAILURE`,
  CREATE_REQUEST: `${FACILITY_SHIFT_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${FACILITY_SHIFT_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${FACILITY_SHIFT_PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${FACILITY_SHIFT_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${FACILITY_SHIFT_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${FACILITY_SHIFT_PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${FACILITY_SHIFT_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${FACILITY_SHIFT_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${FACILITY_SHIFT_PREFIX}DELETE_FAILURE`,
  CLEAR_NOTIFY: `${FACILITY_SHIFT_PREFIX}CLEAR_NOTIFY`
}
